// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3XkOp","overflowing":"ReadFullNote_overflowing__w-fG0"};